/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Posts_Title_PlaceholderInputs */

const en_admin_posts_title_placeholder = /** @type {(inputs: Admin_Posts_Title_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Post title`)
};

/**
* | output |
* | --- |
* | "Post title" |
*
* @param {Admin_Posts_Title_PlaceholderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_posts_title_placeholder = /** @type {((inputs?: Admin_Posts_Title_PlaceholderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Posts_Title_PlaceholderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_posts_title_placeholder(inputs)
});
export { admin_posts_title_placeholder as "admin.posts.title_placeholder" }